import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { z } from 'zod';

export const LayoutGridItem: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { children, config } = templateComponent;

  const configSchema = z.optional(
    z.object({
      colSpan: z.number(),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success || !children || children.length === 0) {
    return null;
  }

  const { colSpan } = result.data ?? {};

  return (
    <UitkLayoutGridItem colSpan={colSpan}>
      <div>{children && <ExperienceTemplateRenderer templateComponents={children} />}</div>
    </UitkLayoutGridItem>
  );
};
